import en from './en.js';
import ru from './ru.js';
import { addResources } from '../../../locales';

addResources({ en, ru });
